// @ts-nocheck
import styled from 'styled-components';

export const ScheduleReportStyled = styled.div`
  padding: 1rem;
  @media (min-width: 900px) {
    padding: 2rem 13.25rem;
  }

  .scheduleReport {
    &__titleContent {
      align-items: center;
      display: flex;
      flex-direction: row;
      gap: 16px;
      margin-bottom: 24px;
    }

    &__counterContent {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    &__numberText {
      color: ${props => props.theme.uiColors.reportingTextColor};
      font-size: 10px;
      margin-left: 4px;
    }

    &__optionsContainer {
      align-items: flex-end;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 16px;
      margin-bottom: 16px;
    }

    &__periodicitySelector {
      flex-grow: 1;
    }

    &__dateContainer {
      display: flex;
      flex-direction: column;
      gap: 8px;
      width: 337px;
    }

    &__dateLabel {
      color: ${props => props.theme.uiColors.cardItemIcon};
      font-size: 14px;
    }

    &__hoursContainer {
      align-items: flex-end;
      display: flex;
      flex-direction: row;
      gap: 8px;
    }

    &__hourSelector {
      flex-grow: 1;
      min-width: 200px;
    }

    &__timezoneSelector {
      flex-grow: 1;
      max-width: 370px;
    }

    &__buttonsContainer {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      gap: 16px;
      margin-top: 32px;
    }
  }
`;
